import React from 'react';
import TypingAnimation from '../ui/animations/TypingAnimation';
import { trackHeroCTAClick } from '../../mixpanel/events';

const HeroSection = () => {
  const handleCTAClick = () => {
    trackHeroCTAClick();
  };

  return (
    <section className="bg-white px-4 pt-16 pb-20" id="home">
      <div className="pt-10 md:pt-14 lg:pt-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* Illustration */}
          <div className="mb-10">
            <img
              src="/chaostoorder.webp"
              width="475"
              height="253"
              alt="Chaos to Order"
              className="w-full max-w-sm mx-auto h-auto"
            />
          </div>

          {/* Headline */}
          <div className="min-h-48 sm:min-h-36 md:min-h-32 flex items-center justify-center mb-4">
            <h1 className="text-4xl md:text-5xl font-bold text-apple-gray-800 leading-tight text-center">
              <TypingAnimation />
            </h1>
          </div>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-apple-gray-600 mb-8 leading-relaxed">
            Helping non-technical founders work confidently with their dev teams without getting lost, stuck, blindsided, or going broke in the process.
          </p>

          {/* Call to Action Button */}
          <div className="mb-4">
            <a
              href="https://form.typeform.com/to/SLoI0dkA"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCTAClick}
              className="inline-block bg-apple-gray-800 text-white font-semibold py-4 px-8 rounded-lg hover:bg-apple-gray-700 transition-colors duration-200"
            >
              Book Your Assessment Call
            </a>
          </div>

          {/* Supporting Line */}
          <p className="text-sm text-apple-gray-600">
            Free 30-min audit. No pitch. Just clarity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;